import { useState } from 'react'

import styled from 'styled-components'
import zIndex from 'styles/tools/z-index'
import { rem } from 'polished'
import clsx from 'clsx'
import LayoutContainer from 'components/Common/LayoutContainer'
import StickyWithStatus from 'components/Common/StickyWithStatus'
import HorizontalContainerWithFadedOverflow from 'components/Common/HorizontalContainerWithFadedOverflow'

import TextButton from 'LuxKit/Button/TextButton'

const StickyContainer = styled(StickyWithStatus)`
  z-index: ${zIndex.stickyHeader};
  
  &.is-stuck {
    border-bottom: 1px solid ${props => props.theme.palette.neutral.default.six};
    background-color: ${props => props.theme.palette.neutral.default.eight};
  }
`

const MenuButton = styled(TextButton)`
  padding: 0 ${rem(12)};
  span{
    border: none;
  }
`

export interface BrandsByLetter {
  value: string
  brands: Array<App.MerchandiseBrand>
  isDisabled: boolean
}

interface Props {
  brandsByLetter: Array<BrandsByLetter>
}

function MerchandiseBrandsHeader({ brandsByLetter }: Props) {
  const [isStuck, setIsStuck] = useState(false)

  return <StickyContainer
    className={clsx({ 'is-stuck': isStuck })}
    onStuckChange={setIsStuck}
  >
    <LayoutContainer>
      <HorizontalContainerWithFadedOverflow>
        {brandsByLetter.map(letter => (
          <MenuButton
            key={letter.value}
            kind="tertiary"
            variant="default"
            disabled={letter.isDisabled}
            to={`/shop/brands#${letter.value}`}
            size="large"
          >
            {letter.value}
          </MenuButton>
        ))}
      </HorizontalContainerWithFadedOverflow>
    </LayoutContainer>
  </StickyContainer>
}

export default MerchandiseBrandsHeader
